import React, { useEffect, useState } from "react";
import { Spin, Empty, message, Modal } from "antd";
import axios from "axios";
import { useParams } from "react-router-dom";
import ProductListCard from "../Product/ProductListCard";
import ProductDetail from "../Product/ProductDetail";
import "../Common/CollectionPage.css";

const TrendingItemsList = ({ refreshCartCount }) => {
  const [trendingApiData, setTrendingApiData] = useState([]);
  const [loadingTrending, setLoadingTrending] = useState(true);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [showPrice, setShowPrice] = useState(!!localStorage.getItem("token"));
  const [showProductModal, setShowProductModal] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const { categoryName } = useParams(); // Get category from URL

  useEffect(() => {
    const fetchTrendingItems = async () => {
      setLoadingTrending(true);
      try {
        const tokenString = localStorage.getItem("token");
        const response = await axios.get(
          global.config.APIURL.BaseURL + "api/TrendingItems/GetTrendingItems",
          {
            headers: {
              Authorization: "Bearer " + tokenString,
            },
          }
        );
        setTrendingApiData(response.data || []);
      } catch (error) {
        message.error("Failed to load trending items.");
        setTrendingApiData([]);
      } finally {
        setLoadingTrending(false);
      }
    };
    fetchTrendingItems();
    logUserActivity();
  }, []);

  useEffect(() => {
    const updateShowPrice = () => setShowPrice(!!localStorage.getItem("token"));
    updateShowPrice();
    window.addEventListener("storage", updateShowPrice);
    return () => window.removeEventListener("storage", updateShowPrice);
  }, []);

  const logUserActivity = async () => {
    const tokenString = localStorage.getItem("token");

    try {
      const jsondata = JSON.stringify({
        ScreenID: "1003",
        DetailID: "0",
      });

      let config = {
        method: "post",
        url: global.config.APIURL.BaseURL + "api/UserActivity/InsertActivity",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
        data: jsondata,
      };

      axios
        .request(config)
        .then((response) => {})
        .catch((error) => {});
    } catch (err) {}
  };

  // All category names for filter chips
  const allCategoryNames = trendingApiData.map((cat) => cat.Category);

  // Select category from URL if available, otherwise select all
  useEffect(() => {
    if (trendingApiData.length > 0) {
      if (categoryName && allCategoryNames.includes(categoryName)) {
        setSelectedCategories([categoryName]);
      } else {
        setSelectedCategories(allCategoryNames);
      }
    }
    // eslint-disable-next-line
  }, [trendingApiData, categoryName]);

  // Handle chip toggle
  const toggleCategory = (cat) => {
    setSelectedCategories((prev) =>
      prev.includes(cat)
        ? prev.filter((c) => c !== cat)
        : [...prev.filter((c) => c !== cat), cat]
    );
  };

  // Handle "All" chip
  const isAllChecked =
    selectedCategories.length === allCategoryNames.length &&
    allCategoryNames.length > 0;

  // Filtered categories to display:
  // - If all categories are selected (default), show in original order
  // - If user selects (ticks) categories, show most recently ticked at top
  const filteredData =
    selectedCategories.length === allCategoryNames.length
      ? allCategoryNames
          .map((catName) =>
            trendingApiData.find((cat) => cat.Category === catName)
          )
          .filter(Boolean)
      : [...selectedCategories]
          .reverse() // latest checked at top
          .map((catName) =>
            trendingApiData.find((cat) => cat.Category === catName)
          )
          .filter(Boolean);

  const handleProductClick = (product) => {
    setSelectedProductId(product.ProductID);
    setShowProductModal(true);
  };

  return (
    <div className="collection-page">
      <div className="collection-header">
        <h1>Trending Products</h1>
        <p>Most-loved designs right now</p>
      </div>

      {!loadingTrending && allCategoryNames.length > 0 && (
        <div className="collection-chips">
          <button
            type="button"
            className={`collection-chip ${
              isAllChecked ? "collection-chip--active" : ""
            }`}
            onClick={() =>
              setSelectedCategories(isAllChecked ? [] : allCategoryNames)
            }
          >
            All
          </button>
          {allCategoryNames.map((cat) => (
            <button
              key={cat}
              type="button"
              className={`collection-chip ${
                selectedCategories.includes(cat) ? "collection-chip--active" : ""
              }`}
              onClick={() => toggleCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
      )}

      {loadingTrending ? (
        <div style={{ textAlign: "center", padding: 72 }}>
          <Spin size="large" />
        </div>
      ) : filteredData.length === 0 ? (
        <Empty
          description={
            selectedCategories.length === 0
              ? "Select at least one category"
              : "No trending products found"
          }
          style={{ padding: "64px 0" }}
        />
      ) : (
        filteredData.map((cat, idx) => (
          <section className="collection-section" key={cat.Category || idx}>
            <div className="collection-section__head">
              <h2 className="collection-section__title">{cat.Category}</h2>
              <span className="collection-section__rule" />
              <span className="collection-section__count">
                {(cat.Products || []).length} items
              </span>
            </div>
            <div className="collection-grid">
              {(cat.Products || []).map((item, pidx) => (
                <ProductListCard
                  key={item.ProductID || pidx}
                  product={item}
                  showProdStatus
                  showPrice={showPrice}
                  onClick={handleProductClick}
                />
              ))}
            </div>
          </section>
        ))
      )}

      {/* Product Detail Modal */}
      <Modal
        open={showProductModal}
        onCancel={() => {
          setShowProductModal(false);
          setSelectedProductId(null);
        }}
        footer={null}
        width="90%"
        style={{ maxWidth: 900 }}
        destroyOnClose
        styles={{ padding: 0 }}
      >
        {showProductModal && selectedProductId && (
          <ProductDetail
            refreshCartCount={refreshCartCount}
            productIdQuery={selectedProductId}
            isModal
            setDocumentTitle={() => {}}
          />
        )}
      </Modal>
    </div>
  );
};

export default TrendingItemsList;
